import type { WorkLocationResponse } from '../../business-profile-setup/types';
import { peopleGateway } from '../index';
import type { CompanyWorkLocationOption } from '../types';

/**
 * After the server created a location: the people lookup, refreshed (it is the source of truth), still containing the new location. If the
 * refresh fails the saved location is added to `current` so a successful save is never lost from the screen. `selectable` is false for an
 * inactive location, which the server will not accept as an assignment.
 */
export async function locationsAfterAdd(
  created: WorkLocationResponse,
  current: CompanyWorkLocationOption[],
  /** Add Employee lists only active locations; the profile keeps every status so history can still name a closed one. */
  activeOnly = true,
): Promise<{ locations: CompanyWorkLocationOption[]; selectable: boolean }> {
  const option: CompanyWorkLocationOption = { id: created.id, name: created.name, locationCode: created.locationCode, status: created.status, isDefault: created.isDefault };
  let base = current;
  try {
    const fresh = await peopleGateway.listCompanyWorkLocations();
    base = activeOnly ? fresh.filter((x) => x.status === 'Active') : fresh;
  } catch {
    /* keep what is on screen */
  }
  const selectable = option.status === 'Active';
  return { locations: !base.some((x) => x.id === created.id) && (selectable || !activeOnly) ? [...base, option] : base, selectable };
}
